
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  
  var bar = $(".topbar"), lastY = window.scrollY;
  window.addEventListener("scroll", function () {
    var y = window.scrollY;
    if (!bar) return;
    bar.classList.toggle("scrolled", y > 8);
    var menuOpen = $(".dd.open") || $(".drawer.open");
    bar.classList.toggle("hide", !menuOpen && y > 420 && y > lastY + 4);
    if (y < lastY - 4) bar.classList.remove("hide");
    lastY = y;
  }, { passive: true });
  
  $$(".dd").forEach(function (dd) {
    var b = $("button", dd);
    b.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = !dd.classList.contains("open");
      $$(".dd.open").forEach(function (o) { o.classList.remove("open"); $("button", o).setAttribute("aria-expanded", "false"); });
      dd.classList.toggle("open", open); b.setAttribute("aria-expanded", String(open));
    });
  });
  document.addEventListener("click", function () { $$(".dd.open").forEach(function (o) { o.classList.remove("open"); $("button", o).setAttribute("aria-expanded", "false"); }); });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { $$(".dd.open").forEach(function (o) { o.classList.remove("open"); }); var d = $(".drawer.open"); if (d) toggleDrawer(false); }
  });
  
  var burger = $(".burger"), drawer = $(".drawer");
  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle("open", open); burger.setAttribute("aria-expanded", String(open));
    document.body.style.overflow = open ? "hidden" : "";
  }
  if (burger) burger.addEventListener("click", function () { toggleDrawer(!drawer.classList.contains("open")); });
  
  var pz = $(".pause");
  if (pz) pz.addEventListener("click", function () {
    var h = pz.closest(".hero"); var p = h.classList.toggle("paused");
    pz.setAttribute("aria-label", p ? "Play background motion" : "Pause background motion");
    pz.innerHTML = p ? '<svg viewBox="0 0 16 16"><path d="M4 2l10 6-10 6z"/></svg>' : '<svg viewBox="0 0 16 16"><path d="M3 2h4v12H3zM9 2h4v12H9z"/></svg>';
  });
  if (reduce) $$(".hero").forEach(function (h) { h.classList.add("paused"); });
  
  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      if (el.classList.contains("rv")) { el.classList.add("in"); el.classList.remove("pre"); }
      if (el.classList.contains("ba")) el.classList.remove("pre");
      if (el.hasAttribute("data-count")) countUp(el);
      io.unobserve(el);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }) : null;
  function belowFold(el) { return el.getBoundingClientRect().top > window.innerHeight * 0.92; }
  if (io && !reduce) {
    $$(".rv").forEach(function (el) { if (belowFold(el)) { el.classList.add("pre"); io.observe(el); } });
    $$(".ba").forEach(function (el) { if (belowFold(el)) { el.classList.add("pre"); io.observe(el); } });
    $$("[data-count]").forEach(function (el) { if (belowFold(el)) io.observe(el); });
  }
  
  $$(".chain").forEach(function (c) {
    if (reduce || !io) { c.classList.add("run"); return; }
    var o = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { c.classList.add("run"); o.disconnect(); } }); }, { threshold: 0.35 });
    o.observe(c);
  });
  
  function countUp(el) {
    var end = parseFloat(el.getAttribute("data-count")), dec = (el.getAttribute("data-count").split(".")[1] || "").length;
    var from = parseFloat(el.getAttribute("data-from") || "0"), t0 = null, dur = 1400;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = (from + (end - from) * e).toFixed(dec);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  
  $$("[data-tabs]").forEach(function (root) {
    var tabs = $$('[role="tab"]', root), panels = $$(".panel", root);
    function show(id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("aria-controls") === id; t.setAttribute("aria-selected", String(on)); t.tabIndex = on ? 0 : -1;
        if (on && focus && t.offsetParent) t.focus();
        var strip = on && t.offsetParent && t.closest(".hscroll-tabs");
        if (strip) strip.scrollTo({ left: Math.max(0, t.offsetLeft - strip.offsetLeft - 24), behavior: reduce ? "auto" : "smooth" });
      });
      panels.forEach(function (p) { p.classList.toggle("on", p.id === id); });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { show(t.getAttribute("aria-controls")); });
      t.addEventListener("keydown", function (e) {
        var vis = tabs.filter(function (x) { return x.offsetParent; }), j = vis.indexOf(t);
        if (e.key === "ArrowDown" || e.key === "ArrowRight") { e.preventDefault(); var n = vis[(j + 1) % vis.length]; show(n.getAttribute("aria-controls"), true); }
        if (e.key === "ArrowUp" || e.key === "ArrowLeft") { e.preventDefault(); var p = vis[(j - 1 + vis.length) % vis.length]; show(p.getAttribute("aria-controls"), true); }
      });
    });
    function fromHash() {
      var id = (location.hash || "").slice(1);
      if (id && panels.some(function (p) { return p.id === id; })) { show(id); root.scrollIntoView({ block: "start", behavior: reduce ? "auto" : "smooth" }); }
    }
    fromHash(); window.addEventListener("hashchange", fromHash);
    root._show = show; root._ids = panels.map(function (p) { return p.id; });
  });
  
  $$("[data-phones]").forEach(function (st) {
    var ph = $$(".phone", st), btns = $$(".pdots button", st), cur = 0, timer = null;
    function set(i) {
      cur = (i + ph.length) % ph.length;
      ph.forEach(function (p, k) {
        var d = (k - cur + ph.length) % ph.length;
        p.setAttribute("data-pos", d === 0 ? "front" : d === 1 ? "right" : "left");
        p.setAttribute("aria-hidden", String(d !== 0));
      });
      btns.forEach(function (b, k) { b.setAttribute("aria-pressed", String(k === cur)); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    ph.forEach(function (p, k) { p.addEventListener("click", function () { stop(); set(k); }); });
    btns.forEach(function (b, k) { b.addEventListener("click", function () { stop(); set(k); }); });
    st.addEventListener("mouseenter", stop); st.addEventListener("focusin", stop); st.addEventListener("touchstart", stop, { passive: true });
    set(0);
    if (!reduce) timer = setInterval(function () { if (st.offsetParent) set(cur + 1); }, 4200);
  });
  
  $$(".railwrap").forEach(function (w) {
    var r = $(".rail", w), prev = $("[data-prev]", w.parentNode), next = $("[data-next]", w.parentNode);
    function by(d) { var c = $(".card", r); r.scrollBy({ left: d * (c ? c.getBoundingClientRect().width + 6 : 360), behavior: reduce ? "auto" : "smooth" }); }
    if (prev) prev.addEventListener("click", function () { by(-1); });
    if (next) next.addEventListener("click", function () { by(1); });
  });
  
  var map = $("[data-millmap]");
  if (map) {
    var data = JSON.parse($("#millmap-data").textContent), info = map.closest(".millmap").querySelector(".mapinfo");
    var lb = $("#millmap-labels"); lb = lb ? JSON.parse(lb.textContent) : { adds: "What AIREI adds", next: "Next", end: "End of the line — every station reports here." };
    var order = Object.keys(data);
    function pick(id) {
      var d = data[id]; if (!d) return;
      var i = order.indexOf(id), nx = data[order[i + 1]];
      $$(".stn", map).forEach(function (s) {
        var j = order.indexOf(s.getAttribute("data-id"));
        s.classList.toggle("on", j === i); s.classList.toggle("done", j < i);
      });
      info.innerHTML = (d.img ? '<div class="mi-img"><img alt="' + d.t.replace(/"/g, "&quot;") + '" src="' + d.img + '"></div>' : "") +
        '<div class="mi-body"><p class="mi-count">' + String(i + 1).padStart(2, "0") + " / " + String(order.length).padStart(2, "0") + '</p>' +
        '<p class="eyebrow">' + d.zone + '</p><h3>' + d.t + '</h3><p>' + d.what + '</p><p class="mi-h">' + lb.adds + '</p><ul>' +
        d.ai.map(function (x) { return "<li>" + x + "</li>"; }).join("") + "</ul>" +
        (nx ? '<p class="mi-next">' + lb.next + " · " + nx.t + "</p>" : '<p class="mi-next">' + lb.end + "</p>") + "</div>";
      fit();
    }
    function fit() {
      info.classList.remove("fit1", "fit2");
      if (info.scrollHeight <= info.clientHeight) return;
      info.classList.add("fit1");
      if (info.scrollHeight <= info.clientHeight) return;
      info.classList.remove("fit1"); info.classList.add("fit2");
    }
    window.addEventListener("resize", function () { requestAnimationFrame(fit); });
    map._pick = pick; map._ids = order;
    $$("[data-igview]", map.closest(".millmap")).forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-igview"); map.setAttribute("data-view", v);
        $$("[data-igview]", map.closest(".millmap")).forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
      });
    });
    $$(".stn", map).forEach(function (s) {
      s.setAttribute("tabindex", "0"); s.setAttribute("role", "button");
      s.addEventListener("click", function () { pick(s.getAttribute("data-id")); });
      s.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); pick(s.getAttribute("data-id")); } });
    });
    pick(map.getAttribute("data-start"));
  }
  
  var route = $("[data-route]");
  if (route) {
    $$(".rt-row", route).forEach(function (b) {
      b.addEventListener("click", function () {
        var id = b.getAttribute("data-open"), li = null;
        $$(".rt-stop", route).forEach(function (s) {
          var on = s.getAttribute("data-id") === id; s.classList.toggle("on", on); if (on) li = s;
          var r = $(".rt-row", s); if (r) r.setAttribute("aria-expanded", on ? "true" : "false");
        });
        if (li) {
          var top = li.getBoundingClientRect().top;
          if (top < 0 || top > window.innerHeight * 0.45) li.scrollIntoView({ block: "start", behavior: reduce ? "auto" : "smooth" });
        }
      });
    });
  }
  
  var scrollyMQ = window.matchMedia("(min-width: 1061px) and (min-height: 760px)");
  $$("[data-scrolly]").forEach(function (sc) {
    var kind = sc.getAttribute("data-scrolly");
    var target = kind === "tabs" ? $("[data-tabs]", sc) : $("[data-millmap]", sc);
    if (!target) return;
    var ids = target._ids || [], set = kind === "tabs" ? target._show : target._pick, cur = -1;
    if (!ids.length || !set) return;
    function active() { return scrollyMQ.matches && !reduce; }
    function sync() {
      sc.classList.toggle("on", active());
      if (!active()) return;
      var r = sc.getBoundingClientRect(), span = sc.offsetHeight - window.innerHeight;
      var p = span > 0 ? Math.min(0.9999, Math.max(0, -r.top / span)) : 0;
      var i = Math.floor(p * ids.length);
      if (i !== cur) { cur = i; set(ids[i]); }
    }
    function jumpTo(id) {                        // a click moves the page to that station's step
      if (!active()) return;
      var i = ids.indexOf(id); if (i < 0) return;
      var top = window.scrollY + sc.getBoundingClientRect().top, span = sc.offsetHeight - window.innerHeight;
      window.scrollTo({ top: top + span * (i + 0.5) / ids.length, behavior: "auto" });
    }
    sc.addEventListener("click", function (e) {
      var t = e.target.closest('[role="tab"], .stn'); if (!t) return;
      jumpTo(t.getAttribute("aria-controls") || t.getAttribute("data-id"));
    });
    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    if (scrollyMQ.addEventListener) scrollyMQ.addEventListener("change", sync);
    sync();
  });
  
  var steps = $(".steps");
  if (steps && !reduce) {
    var prog = $(".prog", steps), items = $$(".step", steps);
    function upd() {
      var r = steps.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.max(0, Math.min(1, (vh * 0.6 - r.top) / r.height));
      prog.style.setProperty("--p", p);
      items.forEach(function (it) { it.classList.toggle("lit", it.getBoundingClientRect().top < vh * 0.6); });
    }
    window.addEventListener("scroll", upd, { passive: true }); upd();
  } else if (steps) { $$(".step", steps).forEach(function (s) { s.classList.add("lit"); }); var pg = $(".prog", steps); if (pg) pg.style.setProperty("--p", 1); }
  
  var px = $$("[data-parallax]");
  if (px.length && !reduce && window.matchMedia("(min-width: 861px)").matches) {
    var tick = false;
    function par() {
      px.forEach(function (im) {
        var r = im.parentNode.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var k = (r.top + r.height / 2 - vh / 2) / vh;
        im.style.transform = "translateY(" + (-k * 36).toFixed(1) + "px)";
      });
      tick = false;
    }
    window.addEventListener("scroll", function () { if (!tick) { tick = true; requestAnimationFrame(par); } }, { passive: true }); par();
  }
  
  $$("[data-film]").forEach(function (b) {
    b.addEventListener("click", function () {
      var d = $("#filmdlg"); if (!d) return;
      var v = $("video", d); v.src = b.getAttribute("data-film");
      d.showModal(); if (!reduce) v.play().catch(function () {});
    });
  });
  var dlg = $("#filmdlg");
  if (dlg) {
    var close = function () { var v = $("video", dlg); v.pause(); dlg.close(); };
    $(".x", dlg).addEventListener("click", close);
    dlg.addEventListener("click", function (e) { if (e.target === dlg) close(); });
  }
  
  var nb = $("#notesBtn");
  if (nb) nb.addEventListener("click", function () {
    var on = document.documentElement.getAttribute("data-notes") !== "on";
    document.documentElement.setAttribute("data-notes", on ? "on" : "off"); nb.setAttribute("aria-pressed", String(on));
  });
  
  var pf = $("form#assessment");
  if (pf && location.search) {
    var q = new URLSearchParams(location.search), map = { name: "f-name", company: "f-co", country: "f-country", tph: "f-tph", oer: "f-oer", contact: "f-contact", message: "f-msg" };
    Object.keys(map).forEach(function (k) {
      var v = (q.get(k) || "").slice(0, 400), el = document.getElementById(map[k]);
      if (!v || !el || el.value && el.tagName !== "SELECT") return;
      if (el.tagName === "SELECT") { $$("option", el).forEach(function (o) { if (o.value.toLowerCase() === v.toLowerCase() || o.textContent.toLowerCase() === v.toLowerCase()) el.value = o.value; }); }
      else el.value = v;
    });
  }
  
  var f = $("form[data-mailto]");
  if (f) f.addEventListener("submit", function (e) {
    e.preventDefault();
    var lines = $$("label", f).map(function (l) {
      var c = $("input,select,textarea", l), t = Array.prototype.filter.call(l.childNodes, function (n) { return n.nodeType === 3; })
        .map(function (n) { return n.textContent.trim(); }).join(" ").trim();
      return c && c.value.trim() ? t + ": " + c.value.trim() : "";
    }).filter(Boolean);
    var subj = ($(".formsubj", f) || {}).textContent || "", ok = $(".formok", f), m = $(".formmsg", f);
    window.location.href = "mailto:" + f.getAttribute("data-mailto") + "?subject=" + encodeURIComponent(subj) + "&body=" + encodeURIComponent(lines.join("\n"));
    if (m && ok) m.textContent = ok.textContent;
  });
})();
